<template>
    <team-form v-if="team" :team="team"></team-form>
</template>

<script>
    import axios from 'axios';
    import TeamForm from '../components/TeamForm'
    export default {
        name: 'teams-edit',
        data () {
            return {
                team: false
            }
        },
        components: {
            TeamForm
        },
        mounted() {
            axios
                .get('/api/teams/' + this.$route.params.id)
                .then((response) => {
                    this.team = response.data.data
                })
        }
    }
</script>
